import {
    GenericTextInlineEditor,
    GenericTextInlineEditorProps,
} from 'components/inline_edit/GenericTextInlineEditor';
import { noConvert } from 'components/inline_edit/InlineEditor';

export type TextInlineEditorProps = Omit<
    GenericTextInlineEditorProps<string>,
    'serialize' | 'deserialize'
>;

export function TextInlineEditor(props: TextInlineEditorProps) {
    return (
        <GenericTextInlineEditor
            serialize={noConvert}
            deserialize={noConvert}
            {...props}
        />
    );
}
